/*
  Opravy filtru ceny na mobilu podle Lenčina testování 30. 7. 2026.

  1) Posuvník nešel táhnout prstem.
     Posuvník je widget jQuery UI .slider(). Touch Punch mapuje dotykové
     události na myš tím, že záplatuje $.ui.mouse.prototype._mouseInit —
     jenže ta záplata platí až pro widgety vytvořené PO ní. script.min.js
     přitom volá $("#slider-range").slider({...}) rovnou při parsování
     (znak 263288; jediný $(function(...) v souboru je až na 266279, takže
     inicializaci neobaluje), tedy dřív, než se Touch Punch vůbec stáhne.

     Řešení: na hotovou instanci dovážeme jen ty tři dotykové obsluhy,
     které by přidal záplatovaný _mouseInit. Nic se neodpojuje.
     (První verze volala _mouseDestroy() + _mouseInit(); tažení sice
     fungovalo, ale posuvník ztratil růžovou výplň. Příčinu se mi
     z kódu určit nepodařilo, tak se tomu volání vyhýbáme úplně —
     tohle dělá totéž a nesahá na to, co už funguje.)

  2) Do políček ceny nešlo psát — „ať napíšu cokoliv, dá mi to před moje
     číslo číslo 60".
     Obsluha input ve script.min.js po 600 ms ořízne hodnotu na povolený
     rozsah a přepíše obsah políčka. Během psaní je ale mezivýsledek často
     mimo rozsah (napsaná „2", když je v druhém políčku 60), takže do
     políčka skočí 60 a další číslice se lepí za ně.

     Řešení: původní obsluhu odpojíme. Při psaní jen posouváme osu, a to
     pouze když je hodnota v rozsahu. Ořez děláme až při opuštění políčka.
*/
(function () {
  var $ = window.jQuery;
  if (!$ || !$.ui || !$.ui.mouse) return;

  var OSA = '#slider-range';
  var POLE = '.slider-change-value';

  function meze() {
    return {
      min: parseInt($('#slider-min').val(), 10),
      max: parseInt($('#slider-max').val(), 10)
    };
  }

  function posun(pozice, hodnota) {
    try {
      $(OSA).slider('values', pozice, hodnota);
    } catch (e) {}
  }

  function pozicePole($pole) {
    return $pole.hasClass('slider-change-value-max') ? 1 : 0;
  }

  $(function () {
    // --- 1) dotykové ovládání posuvníku ---
    // Na počítači není co řešit, myš je navázaná od začátku.
    if ($.support && $.support.touch) {
      var $osa = $(OSA);
      var instance = $osa.length && ($osa.data('ui-slider') || $osa.data('uiSlider'));
      if (instance && typeof instance._touchStart === 'function') {
        try {
          instance.element.on({
            touchstart: $.proxy(instance, '_touchStart'),
            touchmove: $.proxy(instance, '_touchMove'),
            touchend: $.proxy(instance, '_touchEnd')
          });
        } catch (e) {
          // Radši nechat posuvník tak, jak byl, než rozbít stránku.
        }
      }
    }

    // --- 2) psaní do políček ceny ---
    if (!$(POLE).length) return;
    $('html').off('input', POLE);

    $('html').on('input', POLE, function () {
      var $pole = $(this);
      var hodnota = parseInt($pole.val(), 10);
      if (isNaN(hodnota)) return;
      var m = meze();
      // Rozepsané číslo mimo rozsah necháme být, uživatel ještě píše.
      if (hodnota < m.min || hodnota > m.max) return;
      posun(pozicePole($pole), hodnota);
    });

    $('html').on('change focusout', POLE, function () {
      var $pole = $(this);
      var pozice = pozicePole($pole);
      var m = meze();
      var hodnota = parseInt($pole.val(), 10);
      var vMin = parseInt($('.slider-change-value-min').val(), 10);
      var vMax = parseInt($('.slider-change-value-max').val(), 10);

      if (isNaN(hodnota)) hodnota = pozice === 0 ? m.min : m.max;
      if (hodnota < m.min) hodnota = m.min;
      if (hodnota > m.max) hodnota = m.max;
      // Spodní hranice nesmí přeskočit horní a naopak.
      if (pozice === 0 && !isNaN(vMax) && hodnota > vMax) hodnota = vMax;
      if (pozice === 1 && !isNaN(vMin) && hodnota < vMin) hodnota = vMin;

      $pole.val(hodnota);
      posun(pozice, hodnota);
    });
  });
})();
